export default __webpack_public_path__ + "static/media/Stress Exploration worksheet.1ae97379.pdf";